import '../../../common/dashboard/filters/unapplied/toggleable_unapplied_filter_view.js.coffee'
Namespace 'CustomerVisualMode.Filters.Unapplied'

class CustomerVisualMode.Filters.Unapplied.UnappliedDateFilterView extends
Common.Dashboard.Filters.ToggleableUnappliedFilterView
  events: ->
    _.defaults(
      Common.Dashboard.Filters.ToggleableUnappliedFilterView.prototype.events
      'change .date-filter-type': '_toggleSelectorPickers'
    )

  render: ->
    super()
    @_renderTypeSelectors()
    @_toggleSelectorPickers()
    @

  _displayTitle: ->
    I18n.t 'customer_visual_mode.filters.date.title'

  _renderTypeSelectors: ->
    @typeSelectorViews ||= {}
    view.remove() for _name, view of @typeSelectorViews
    @typeSelectorViews = {
      realtime: @_renderRealtimeSelector @_dateRealtimeSelector()
      date_range: @_renderRangeSelector @_dateRangeSelector()
    }

  _renderRangeSelector: ({range, isChecked, rangeType}) ->
    rangeSelectorView = new CustomerVisualMode.Filters.Unapplied.UnappliedDateFilterTypeSelectorView
      rangeType: rangeType
      range: range
      isChecked: isChecked
    @$('.filter-body').append rangeSelectorView.render().el
    rangeSelectorView

  _renderRealtimeSelector: ({range, isChecked, value}) ->
    realtimeSelectorView = new CustomerVisualMode.Filters.Unapplied.UnappliedDateRealtimeFilterTypeSelectorView
      isChecked: isChecked
      value: value
    @$('.filter-body').append realtimeSelectorView.render().el
    realtimeSelectorView

  _getSelectedValues: ->
    if @_selectedFilterType() in CustomerVisualMode.Filters.DateFilter.RANGE_TYPES
      @_rangeSelectedValue()
    else
      @_realtimeSelectedValue()

  _rangeSelectedValue: ->
    type: @typeSelectorViews.date_range.selectedRangeType()
    start_time: @_formattedTime @_selectedRange().start_time
    end_time: @_formattedTime @_selectedRange().end_time if @_selectedRange().end_time

  _selectedRange: ->
    @typeSelectorViews.date_range.selectedModifier()

  _formattedTime: (datetime) ->
    datetime.format 'YYYY-MM-DDTHH:mm:ssZ'

  _realtimeSelectedValue: ->
    selected = @typeSelectorViews.realtime.selectedModifier()
    {
      type: selected.type
      time_interval_in_seconds: selected.time_interval_in_seconds
    }

  _selectedFilterType: ->
    @$("input[name='date-filter-type']:checked").val()

  _toggleSelectorPickers: ->
    @typeSelectorViews.date_range.togglePickers()
    @typeSelectorViews.realtime.toggleSelector()

  _dateRealtimeSelector: ->
    isSelected = @filter.isRealtime()
    value = @filter.getValues()

    isChecked: isSelected
    value: if isSelected then value.time_interval_in_seconds || value.type else @filter.constructor.TYPES.CURRENT_DAY

  _dateRangeSelector: ->
    isSelected = @filter.isRange()
    value = @filter.getValues()

    range:
      start_time: Date.create(if isSelected then value.start_time else moment().startOf('day'))
      end_time: Date.create(if isSelected then value.end_time else moment().startOf('day'))
    isChecked: isSelected
    rangeType: value.type
